// extracted by mini-css-extract-plugin
export var skipLink = "cj_kD";